import * as lib from '~/dependencies';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  machineId: null,
  OS: null,
  dev: false,
  console: false,
  status: actionTypes.STATUS.UNAVAILABLE,
  transfer: null,
  ringDevice: null,
  ringTone: 'default',
  internalRingtone: 'classicvibes',
  statusSound: [],
  remoteVideo: null,
  localVideo: [],
  volume: null,
  numberToTransfer: null,
  numberContactToTransfer: null,
  callerIdCountryCode: null,
  temporaryCountryCode: null,
  temporaryISOCode: null,
  checkForUpdates: null,
  userInteraction: null,
  // NOTE: requestTransfer & requestConference has been deprecieted. Use Session now
  requestTransfer: false,
  requestConference: false,
  startOnBoot: true,
  lastHistoryCheck: lib.dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  lastSeenContacts: null,
  lastRequestedContacts: null,
  checkedContacts: true,
  version: '',
  deviceManager: { audio: {} },
  userPreferences: { audio: {} },
  newVersionAvailable: [],
  updaterDateTime: null,
  showUpdaterMessage: true,
  smsTermAccepted: false,
  lastDialedNumber: null,
  callWaitingSound: false,
  isBusy: false,
  disableKeypadTone: false,
};

// eslint-disable-next-line no-unused-vars
const { ...noRingTone } = initialState;

const system = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SYSTEM_SAVE:
      return {
        ...state,
        machineId: action.payload.machineId,
        OS: action.payload.OS,
      };
    case actionTypes.DEV_MODE:
      return {
        ...state,
        dev: action.payload.dev,
      };
    case actionTypes.CONSOLE:
      return {
        ...state,
        console: action.payload.console,
      };
    case actionTypes.STATUS_SYSTEM:
      return {
        ...state,
        status: action.payload.status,
      };
    case actionTypes.SET_REMOTE_VIDEO:
      return {
        ...state,
        remoteVideo: action.payload.remoteVideo,
      };
    case actionTypes.SET_LOCAL_VIDEO:
      return {
        ...state,
        localVideo: action.payload.localVideo,
      };
    case actionTypes.TRANSFER_PREFERENCE:
      return {
        ...state,
        transfer: action.payload.transfer,
      };
    case actionTypes.PHONE_DEVICE_SETUP:
      return {
        ...state,
        deviceManager: {
          audio: action.deviceManager.audio,
        },
      };
    case actionTypes.PHONE_DEVICE_CHANGE:
      return {
        ...state,
        deviceManager: {
          audio: action.deviceManager.audio,
        },
        userPreferences: {
          audio: action.deviceManager.audio,
        },
      };
    case actionTypes.CHECKED_HISTORY:
      return {
        ...state,
        lastHistoryCheck: action.payload.lastHistoryCheck,
      };
    case actionTypes.CHECKED_CONTACTS:
      return {
        ...state,
        lastSeenContacts: action.payload.lastSeenContacts,
        checkedContacts: action.payload.checkedContacts,
        lastRequestedContacts: action.payload.lastRequestedContacts,
      };
    case actionTypes.RING_DEVICE:
      return {
        ...state,
        ringDevice: action.payload.ringDevice,
      };
    case actionTypes.CHANGE_RINGTONE:
      return {
        ...state,
        ringTone: action.payload.ringTone,
        internalRingtone: action.payload.internalRingtone,
      };
    case actionTypes.STATUS_SOUNDS:
      return {
        ...state,
        statusSound: action.payload.statusSound,
      };
    case actionTypes.UPDATE_SOUNDS_DEVICE:
      return {
        ...state,
        sounds: action.payload.sounds,
      };
    case actionTypes.SET_VOLUME:
      return {
        ...state,
        volume: action.payload.volume,
      };
    case actionTypes.SET_VERSION:
      return {
        ...state,
        version: action.payload.version,
      };
    case actionTypes.NUMBER_TO_TRANSFER:
      return {
        ...state,
        numberToTransfer: action.payload.numberToTransfer,
      };
    case actionTypes.NUMBER_CONTACT_TO_TRANSFER:
      return {
        ...state,
        numberContactToTransfer: action.payload.numberContactToTransfer,
      };
    case actionTypes.CALLER_ID_COUNTRY_CODE:
      return {
        ...state,
        callerIdCountryCode: action.payload.callerIdCountryCode,
      };
    case actionTypes.TEMPORARY_COUNTRY_CODE:
      return {
        ...state,
        temporaryCountryCode: action.payload.temporaryCountryCode,
        temporaryISOCode: action.payload.temporaryISOCode,
      };
    case actionTypes.TEMPORARY_ISO_CODE:
      return {
        ...state,
        temporaryISOCode: action.payload.temporaryISOCode,
      };
    case actionTypes.CHECK_UPDATE:
      return {
        ...state,
        checkForUpdates: action.payload.checkForUpdates,
      };
    case actionTypes.USER_INTERACTION_UPDATE_DIALOG:
      return {
        ...state,
        userInteraction: action.payload.userInteraction,
      };
    case actionTypes.NEW_VERSION_AVAILABLE:
      return {
        ...state,
        newVersionAvailable: action.payload.newVersionAvailable,
      };
    case actionTypes.START_ON_BOOT:
      return {
        ...state,
        startOnBoot: action.payload.startOnBoot,
      };
    case actionTypes.RESET_SYSTEM:
      return {
        ...noRingTone,
        version: state.version,
        ringTone: state.ringTone,
        dev: state.dev,
        deviceManager: state.deviceManager,
      };
    case actionTypes.UPDATER_DATE_TIME:
      return {
        ...state,
        updaterDateTime: action.payload.updaterDateTime,
      };
    case actionTypes.UPDATER_MESSAGE:
      return {
        ...state,
        showUpdaterMessage: action.payload.showUpdaterMessage,
      };
    case actionTypes.SET_ACCOUNT_SMS_BILLING_VIEWED:
      return {
        ...state,
        smsTermAccepted: action.smsTermAccepted,
      };
    case actionTypes.SET_LAST_DIALED_NUMBER:
      return {
        ...state,
        lastDialedNumber: action.payload.lastDialedNumber,
      };
    case actionTypes.SET_CALL_WAITING_SOUND:
      return {
        ...state,
        callWaitingSound: action.payload.callWaitingSound,
      };
    case actionTypes.SET_SYSTEM_IS_BUSY:
      return {
        ...state,
        isBusy: action.payload.isBusy,
      };
    case actionTypes.DISABLE_KEYPAD_TONE:
      return {
        ...state,
        disableKeypadTone: action.payload.disableKeypadTone,
      };
    default:
      return {
        ...state,
      };
  }
};

export default system;
